export const LOADING_INVENTORY_TRANSACTION = "LOADING_INVENTORY_TRANSACTION";
export const GET_INVENTORY_TRANSACTION_LIST = "GET_INVENTORY_TRANSACTION_LIST";
export const GET_INVENTORY_TRANSACTION_ID = "GET_INVENTORY_TRANSACTION_ID";
export const REMOVE_INVENTORY_TRANSACTION = "REMOVE_INVENTORY_TRANSACTION";
export const ADD_INVENTORY_TRANSACTION = "ADD_INVENTORY_TRANSACTION";
export const UPDATE_INVENTORY_TRANSACTION = "UPDATE_INVENTORY_TRANSACTION";